// Generated by Ktorfit
@file:Suppress("warnings")

package kpt.core.network.fineract.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import kotlin.collections.Map
import kpt.core.base.network.`annotation`.ApiBinding
import kpt.core.network.fineract.dto.FineractAuthResponseDto
import kpt.core.network.fineract.dto.FineractOfficeDto

@OptIn(InternalKtorfitApi::class)
@ApiBinding(accessPoint = "fineract")
public class _FineractApiImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : FineractApi {
  override suspend fun authenticate(request: Map<String, String>): FineractAuthResponseDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "authentication")
        }
        setBody(request) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<FineractAuthResponseDto>(),)!! 
  }

  override suspend fun offices(): List<FineractOfficeDto> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "offices")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<List<FineractOfficeDto>>(),)!! 
  }
}

public class _FineractApiProvider : ClassProvider<FineractApi> {
  override fun create(_ktorfit: Ktorfit): FineractApi = _FineractApiImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createFineractApi(): FineractApi = _FineractApiImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
